import React from 'react';

class IntervalSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalSwitch: false,
    };
    this.interval = null;
  }

  componentDidMount() {
    const { intervalInMs } = this.props;
    this.interval = setInterval(() => {
      this.setState(prevState => ({
        intervalSwitch: !prevState.intervalSwitch,
      }));
    }, intervalInMs);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { children } = this.props;
    const { intervalSwitch } = this.state;
    return children({ intervalSwitch });
  }
}

export { IntervalSwitch };
